import CandidateJobSection from './CandidateJobSection.component';

export default CandidateJobSection;
